<template>
  <div class="content-item" :class="[type]">
    <div class="content-img-wrap">
      <img class="content-img" :src="info.logo">
    </div>
    <div class="content-text">
      <p class="content-text-name" v-html="info.title"></p>
      <p class="content-text-title" v-html="info.desc" v-if="info.desc" />
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types'

export default {
  name: 'FiItem',

  props: {
    info: VueTypes.object.def({}),
    type: VueTypes.string.def('') // is-weight
  }
}
</script>

<style lang="scss" scoped>
.content-item {
  display: flex; flex-direction: column;
  border-radius: 10px;
  overflow: hidden;

  @include mobile {
    flex-direction: row;
    height: 76px;
  }

  &.is-weight {
    .content-text {
      background: #F9FBFE;

      @include mobile {
        padding: 10px 0 0 18px;
        text-align: left;
      }
    }
    & .content-text-name {
      @include mobile {
        margin-bottom: 0;
        font-size: 16px; line-height: 22px;
      }
    }
    & .content-img {
      width: 132px;
      @include mobile {
        width: 40px;
      }
    }
  }
}
.content-img-wrap {
  @include flexCenter;
  height: 200px;
  background: #E7F2FA;

  @include mobile {
    width: 90px;
    height: 100%;
  }
}
.content-img {
  width: 122px;

  @include mobile {
    width: 40px;
  }
}
.content-text {
  flex: 1;
  padding: 25px 0 33px;
  text-align: center;
  background: #fff;
  @include mobile {
    padding: 10px 0 0 18px;
    text-align: left;
  }
}
.content-text-name {
  margin-bottom: 14px;
  font-size: 20px;
  font-family: Alibaba-PuHuiTi-Heavy;
  color: #404040;
  line-height: 27px;

  @include mobile {
    margin-bottom: 0;
    font-size: 16px; line-height: 22px;
  }
}
.content-text-title {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #616161;
  line-height: 20px;

  @include mobile {
    font-size: 12px; line-height: 17px;
  }
}
</style>
